import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { entityAttributesStateSelector } from '~/selectors';

import { EntityAttributes } from './slice';

export const useEntityAttributes = (): {
  allAttributes: EntityAttributes;
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
} => {
  const attributesStore = useSelector((state: StoreState) => {
    return entityAttributesStateSelector(state);
  });
  return {
    ...attributesStore,
  };
};
